<template>
    <div class="wechat-welcomeing">
        <div class="form-box">
            <el-form ref="form" :model="form" v-loading="formLoading" label-width="100px">
                <el-form-item label="上次修改时间">
                    <p class="time">{{form.updateTime}}</p>
                </el-form-item>
                <el-form-item label="回复类型">
                    <el-radio-group v-model="form.msgtype">
                        <el-radio label="text">文字</el-radio>
                        <el-radio label="image">图片</el-radio>
                    </el-radio-group>
                </el-form-item>
                <template v-if="form.msgtype == 'text'">
                    <el-form-item label="文字">
                        <el-input v-model="form.content" type="textarea" rows="4"  placeholder="请输入回复文字"></el-input>
                    </el-form-item>
                </template>
                <template v-if="form.msgtype == 'image'">
                    <el-form-item label="图片">
                        <cc-uploader :config="uploaderConf2"
                                     :useSuccess="true"
                                     @upload-success="uploadTrue2"
                                     v-if="!form.filePath"
                        />
                        <div class="image-box" v-else :style="`background: url(${form.filePath}) no-repeat center / cover`" @click="showImage">
                            <div class="del-image flex-between" @click.stop="delImage">X</div>
                        </div>
                    </el-form-item>
                </template>
                <div class="save flex-between">
                    <el-button type="primary" size="small" @click="save">保存</el-button>
                </div>

            </el-form>
        </div>
        <el-dialog
                :visible.sync="showImageDialog"
                width="80%"
        >
            <img :src="form.filePath" style="display: block; margin: 0 auto;" alt="">
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "WechatWelcoming",
        data(){
            return {
                uploaderConf2: this.$uploadUtils.config,
                showImageDialog: false,
                formLoading: true,
                form: {
                    filePath: "",
                    msgtype: "text",
                    content: "",
                    type: 0,
                    id: 0,
                    updateTime: "---"
                },
                uploadData: {}
            }
        },
        methods: {
            showImage(){
                this.showImageDialog = true;
            },
            delImage(){
                this.form.filePath = false;
            },
            uploadTrue2(res){
                console.log(res)
                let data = {
                    ...this.form,
                    filePath: res.accessoryUrl,
                    mediaType: "image",
                    fileType: res.fileName.split('.')[1],
                    content: ""
                }
                this.form = data;
            },
            getData(){
                let data = {
                    type: 0
                }
                this.ccRequest.do("wechat/mp/wxMpMessage/query", data, "GET").then(res=>{
                    console.log(res, "aaa")
                    if(res && res.rows){
                        for(let i in res.rows[0]){
                            if(this.form[i] !== undefined){
                                this.form[i] = res.rows[0][i]
                            }
                        }
                    }
                    if(res.rows[0].msgtype === 'image'){
                        this.form.filePath = res.rows[0].imgurl;
                    }
                    this.formLoading = false;
                })
            },
            save(){
                let data = this.form;
                console.log(data);
                this.formLoading = true;
                this.ccRequest.do("wechat/mp/wxMpMessage/fosberMp/save", data, "POSTJSON").then(()=>{
                    this.$message({
                        message: "保存成功",
                        type: "success"
                    });
                    this.formLoading = false;
                }).catch(()=>{
                    this.formLoading = false;
                })

            }
        },
        mounted(){
            this.getData();

        }
    }
</script>

<style scoped lang="scss">
    .wechat-welcomeing{
        background: #ffffff;
        padding: 20px;
        .form-box{
            max-width: 700px;
            .time{
                font-size: 14px;
            }
            .save {
                margin-top: 20px;
                justify-content: center;
            }
        }

    }
    .image-box{
        width: 100px;
        height: 100px;
        border: 1px solid #eeeeee;
        position: relative;
        cursor: pointer;
        .del-image{
            position: absolute;
            border-radius: 50%;
            border: 1px solid #f00;
            color: #f00;
            width: 20px;
            height: 20px;
            justify-content: center;
            text-align: center;
            right: 0;
            top: 0;
            transform: translateY(-50%) translateX(50%);
        }
    }
</style>
